<template>
  <div class="c-table-modal">
    <div
      class="c-table-modal__tabs o-grid o-grid--direction-row o-grid--align-items-center o-grid--justify-content-start"
    >
      <div class="o-grid__group">
        <div
          class="o-grid__item c-table-modal__tab"
          v-for="(tab, name) in tabs"
          tabindex="0"
          :key="name.id"
          :class="{ 'c-table-modal__tab--active': selected === name }"
          @keyup.enter="selected = name"
          @click="selected = name"
        >
          <svg
            class="c-table-modal__tab-icon o-svg-icon"
            viewBox="0 0 64 64"
            type="image/svg+xml"
          >
            <use
              :xlink:href="`spritemap.svg#sprite-` + `${tab.icon}`"
              x="0"
              y="0"
            ></use>
          </svg>
          <span class="c-table-modal__tab-name">
            {{ tab.name }} {{ tabCount(name) }}
          </span>
        </div>
        <div class="o-grid__item c-table-modal__buttons">
          <button
            v-if="['InProgress', 'New'].includes(all.workflowState)"
            class="o-button c-table-modal__button"
            @click="changeWorkflowState('Done')"
          >
            {{ translationsCustom.markAsDone || "" }}
          </button>
          <button
            v-if="all.workflowState === 'New'"
            class="o-button c-table-modal__button"
            @click="changeWorkflowState('InProgress')"
          >
            {{ translationsCustom.markAsInProgress || "" }}
          </button>
        </div>
      </div>
    </div>
    <div class="c-table-modal__content">
      <transition name="o-transition__fade" mode="out-in">
        <component
          v-if="allDataReady && !manufacturersLoading"
          :key="all.aedId"
          :is="`CallCenterAED` + `${selected}`"
        ></component>
      </transition>
    </div>
  </div>
</template>

<script>
import CallCenterAEDreport from "@/components/AED/TAB/report.vue";

import { mapState, mapGetters } from "vuex";

export default {
  name: "c-table-modal",
  data() {
    return {
      tabs: {
        report: {
          name: "Report",
          icon: "hjs-map-and-pin-filled"
        }
      },
      getAllAction: "tip/getAll",
      selected: "report"
    };
  },
  props: {
    itemId: { type: Number, required: true }
  },
  components: {
    CallCenterAEDreport
  },
  computed: {
    ...mapState("tip", ["all", "parameters", "allDataReady"]),
    ...mapState("tips", ["admins"]),
    ...mapGetters("tip", ["status", "assignee"]),
    ...mapState("manufacturers", {
      manufacturersLoading: "loading"
    }),
    ...mapState("translations", {
      translationsCustom: "custom"
    })
  },
  methods: {
    tabCount(name) {
      const count = this.all[name] && this.all[name].length;
      return count !== undefined ? `(${count})` : "";
    },
    changeWorkflowState(state) {
      this.$store.dispatch("tip/changeWorkflowState", {
        id: this.all.id,
        workflowState: state
      });
    }
  },
  created() {
    this.payload = {
      api: this.$api,
      id: this.itemId,
      parameters: this.parameters
    };
    this.$store.dispatch(this.getAllAction, this.payload);
  },
  beforeDestroy() {
    this.$store.dispatch("tip/clearAll");
    this.$store.dispatch("manufacturers/clearSelected");
  }
};
</script>
<style lang="scss">
.c-table-modal {
  $root: &;
  background-color: $s-cp-neutral-800;
  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
  margin: 0 0 2px;
  &__tabs {
    background-color: $s-cp-sup-light;
  }
  &__tab {
    width: 110px;
    height: 85px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 0 0 auto;
    cursor: pointer;

    &--active {
      background-color: $s-cp-neutral-white;
      border-right: 1px solid $s-cp-neutral-600;
      border-left: 1px solid $s-cp-neutral-600;
      &:first-child {
        border-left: 1px solid transparent;
      }

      #{$root}__tab-icon {
        fill: $s-cp-sup-red;
      }
    }
  }
  &__tab-name {
    display: block;
    margin: 0 auto;
    @include setStyles("12", $s-typography-sizes);
    color: $s-cp-neutral-300;
  }
  &__tab-icon {
    fill: $s-cp-neutral-300;
    width: 30px;
    height: 30px;
    margin: 0 auto;
    display: block;
  }
  &__buttons {
    flex: 0 0 auto;
    margin: 0 25px 0 auto;
    display: flex;
    flex-direction: row;
  }

  &__button {
    & + & {
      margin-left: 15px;
    }
  }

  &__content {
    padding: toRem(50px 40px);
    background-color: $s-cp-neutral-white;
    border-top: 1px solid $s-cp-neutral-600;
    margin: -1px 0 1px;
  }
}
</style>
